import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pdf-download",
  "use": "icon-pdf-download-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pdf-download\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.99357 0H4.9934V0.555817H8.99357V0ZM8.99357 1.04222H4.9934V2.10774H8.99357V1.04222ZM12.802 8.89566L12.3269 11.5488H1.66108L1.18644 8.89566H0V13.1244H14V8.89566H12.802ZM8.99635 4.16992H12.5099L6.98451 10.1589L1.52703 4.18191H4.99619V2.6413H8.99635V4.16992Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol